export default "__VITE_ASSET__g1oGbJR3__"